import React, { useState } from 'react';

import GenericPopup from '../../reusable-components/GenericPopup/GenericPopup';
import '../style.less';

function DesktopFooterMenuService({ list }) {
  const [showPopupPrivacy, setPopupPrivacy] = useState(false);
  const [showPopupTerms, setPopupTerms] = useState(false);
  const [showImprintTerms, setImprintTerms] = useState(false);
  const [showWithdrawalTerms, setWithdrawalTerms] = useState(false);
  const [showLegalMentions, setLegalMentions] = useState(false);
  function returnList(items) {
    const noOfItems = () => {
      let counter = 0;
      for (let i = 0; i < items.length; i++) {
        counter++;
        counter += items[i].items.length;
      }
      return counter;
    };
    const noOfColumns = 3;
    const widthOfItem = 100 / noOfColumns;
    const widthOfItemPercent = `${widthOfItem}%`;
    const heightOfItem = 35;
    const heightFormula = Math.ceil(noOfItems() / noOfColumns) * heightOfItem;

    const styleList = {
      height: heightFormula,
      color: 'black',
      width: widthOfItemPercent
    };

    const styleItem = {
      color: 'black',
      lineHeight: '24px'
    };

    const fontWeight = {
      light: {
        fontWeight: 300
      },
      semiBold: {
        fontWeight: 600
      }
    };

    const renderPP = () =>
      showPopupPrivacy && (
        <GenericPopup
          title="Read our terms"
          closeModal={() => setPopupPrivacy(false)}
          type="policy"
          name="privacy"
          target=".site-modal"
        />
      );

    const renderPT = () =>
      showPopupTerms && (
        <GenericPopup
          title="Read our terms"
          closeModal={() => setPopupTerms(false)}
          type="policy"
          name="terms"
          target=".site-modal"
        />
      );

    const renderIT = () =>
      showImprintTerms && (
        <GenericPopup
          title="Read our terms"
          closeModal={() => setImprintTerms(false)}
          type="policy"
          name="imprint"
          target=".site-modal"
        />
      );

    const renderWD = () =>
      showWithdrawalTerms && (
        <GenericPopup
          title="Read our terms"
          closeModal={() => setWithdrawalTerms(false)}
          type="policy"
          name="withdrawal"
          target=".site-modal"
        />
      );

    const renderLM = () =>
      showLegalMentions && (
        <GenericPopup
          title="Read our terms"
          closeModal={() => setLegalMentions(false)}
          type="policy"
          name="legal_information"
          target=".site-modal"
        />
      );

    return (
      <div style={styleList} className="pc-list">
        {renderPT()}
        {renderPP()}
        {renderIT()}
        {renderWD()}
        {renderLM()}
        {items.map(item => {
          return (
            <div key={item.base_item_id} className="pc-list-wrapper">
              <a
                style={{ ...styleItem, ...fontWeight.semiBold }}
                href={`/${item.slug}`}
                target={item.extra_data === 'fullurl' ? '_blank' : ''}
                rel="noreferrer"
              >
                {item.title}
              </a>
              {item.items.length > 0 &&
                item.items
                  .filter(subitem => subitem.online)
                  .map(subitem => {
                    if (subitem.popup) {
                      return (
                        <a
                          role="button"
                          tabIndex="0"
                          style={{ ...styleItem, ...fontWeight.light }}
                          key={subitem.base_item_id}
                          onClick={() => {
                            if (subitem.slug === 'privacy/') {
                              return setPopupPrivacy(true);
                            }
                            if (subitem.slug === 'imprint/') {
                              return setImprintTerms(true);
                            }
                            if (subitem.slug === 'withdrawal/') {
                              return setWithdrawalTerms(true);
                            }
                            if (subitem.slug === '/mentions-legales/') {
                              return setLegalMentions(true);
                            }
                            return setPopupTerms(true);
                          }}
                          className="pc-item"
                        >
                          {subitem.title}
                        </a>
                      );
                    }
                    return (
                      <a
                        style={{ ...styleItem, ...fontWeight.light }}
                        key={subitem.base_item_id}
                        href={
                          subitem.slug.startsWith('http')
                            ? subitem.slug
                            : `/${subitem.slug}`
                        }
                        className="pc-item"
                        target={
                          subitem.extra_data === 'fullurl' ? '_blank' : ''
                        }
                        rel="noreferrer"
                      >
                        {subitem.title}
                      </a>
                    );
                  })}
            </div>
          );
        })}
      </div>
    );
  }
  return <div className="dfms">{returnList(list)}</div>;
}

export default DesktopFooterMenuService;
